import { dejavooPocUiEnabled } from './dejavooPocUi'
import { schedulingUiEnabled } from './schedulingUi'

export const NAV_LINKS = [
  { titleKey: 'nav.dashboard', icon: 'dashboard', link: '/dashboard', ability: null },
  { titleKey: 'nav.salesRegister', icon: 'shopping_cart', link: '/sales/register', ability: 'pos.sell' },
  { titleKey: 'nav.sales', icon: 'point_of_sale', link: '/sales', ability: 'reports.view' },
  { titleKey: 'nav.products', icon: 'inventory_2', link: '/products', ability: 'inventory.view' },
  { titleKey: 'nav.customers', icon: 'people', link: '/customers', ability: 'customers.view' },
  { titleKey: 'nav.leads', icon: 'contact_page', link: '/leads', ability: 'customers.view' },
  { titleKey: 'nav.invoices', icon: 'request_quote', link: '/invoices', ability: 'ar.view', requiresInvoices: true },
  { titleKey: 'nav.projects', icon: 'engineering', link: '/projects', ability: 'projects.view', requiresProjects: true },
  { titleKey: 'nav.tabs', icon: 'receipt_long', link: '/tabs', ability: 'ar.view' },
  { titleKey: 'nav.rentals', icon: 'warehouse', link: '/rentals', ability: 'rentals.view' },
  { titleKey: 'nav.events', icon: 'event', link: '/events', ability: 'events.view' },
  { titleKey: 'nav.booking', icon: 'event_available', link: '/booking', ability: 'scheduling.view' },
  ...(schedulingUiEnabled
    ? [{ titleKey: 'nav.scheduling', icon: 'event_available', link: '/scheduling', ability: 'scheduling.view' }]
    : []),
  { titleKey: 'nav.registers', icon: 'point_of_sale', link: '/registers', ability: 'pos.open-close-register' },
  { titleKey: 'nav.reports', icon: 'bar_chart', link: '/reports', ability: 'reports.view' },
  // Single Settings entry covers Integrations, Users, Business Info
  { titleKey: 'nav.settings', icon: 'settings', link: '/settings', abilityAny: ['settings.view', 'team.view'] },
  ...(dejavooPocUiEnabled
    ? [{ titleKey: 'nav.dejavoo', icon: 'link', link: '/dev/dejavoo', ability: 'payments.view' }]
    : [])
]
